/**
 * Shared visual map + Romanian labels for return-shipment (courier) statuses.
 * Kept in sync with backend `modules/returns/shipments/models.py` STATUS_LABELS.
 */
import {
  Truck, X, CheckCircle2, Clock, AlertTriangle, Package,
} from "lucide-react";

export const SHIPMENT_STATUS_LABELS = {
  draft: "Schiță",
  created: "Neridicat — AWB creat",
  courier_assigned: "Curier alocat",
  out_for_pickup: "În curs de ridicare",
  picked_up: "Ridicat de curier",
  in_transit: "În tranzit",
  at_hub: "În depozit GLS",
  out_for_delivery: "În livrare către depozit",
  delivered: "Ajuns în depozit",
  verified: "Retur verificat",
  completed: "Finalizat",
  cancelled: "Anulat",
  failed: "Eșuat",
  lost: "Pierdut",
  damaged: "Avariat",
};

// Overrides for outbound parcels (warehouse -> client)
export const OUTBOUND_STATUS_LABELS = {
  ...SHIPMENT_STATUS_LABELS,
  created: "AWB creat — în depozit",
  out_for_delivery: "În livrare către client",
  delivered: "Livrat clientului",
};

export function shipmentLabel(status, direction = "inbound") {
  const map = direction === "outbound" ? OUTBOUND_STATUS_LABELS : SHIPMENT_STATUS_LABELS;
  return map[status] || status;
}

export const STATUS_PILL = {
  draft:            { color: "bg-zinc-100 text-zinc-700 border-zinc-200",       dot: "bg-zinc-400",   icon: Clock },
  created:          { color: "bg-sky-50 text-sky-700 border-sky-200",           dot: "bg-sky-500",    icon: Clock },
  courier_assigned: { color: "bg-indigo-50 text-indigo-700 border-indigo-200",  dot: "bg-indigo-500", icon: Truck },
  out_for_pickup:   { color: "bg-violet-50 text-violet-700 border-violet-200",  dot: "bg-violet-500", icon: Truck },
  picked_up:        { color: "bg-purple-50 text-purple-700 border-purple-200",  dot: "bg-purple-500", icon: Package },
  in_transit:       { color: "bg-sky-50 text-sky-700 border-sky-200",           dot: "bg-sky-500",    icon: Truck },
  at_hub:           { color: "bg-amber-50 text-amber-700 border-amber-200",     dot: "bg-amber-500",  icon: Package },
  out_for_delivery: { color: "bg-indigo-50 text-indigo-700 border-indigo-200",  dot: "bg-indigo-500", icon: Truck },
  delivered:        { color: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", icon: CheckCircle2 },
  verified:         { color: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", icon: CheckCircle2 },
  completed:        { color: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", icon: CheckCircle2 },
  cancelled:        { color: "bg-zinc-100 text-zinc-700 border-zinc-200",       dot: "bg-zinc-400",   icon: X },
  failed:           { color: "bg-rose-50 text-rose-700 border-rose-200",         dot: "bg-rose-500",  icon: AlertTriangle },
  lost:             { color: "bg-rose-50 text-rose-700 border-rose-200",         dot: "bg-rose-500",  icon: AlertTriangle },
  damaged:          { color: "bg-orange-50 text-orange-700 border-orange-200",   dot: "bg-orange-500",icon: AlertTriangle },
};
